import { useIntl } from 'react-intl';
import { useDialogState } from '~/modules/common/hooks';

const useTaskAssignmentRowActions = ({ hasTaskAllocation }) => {
  const { formatMessage } = useIntl();
  const {
    open: removeTaskAssignmentDialogOpen,
    openDialog: openRemoveTaskAssignmentDialog,
    closeDialog: closeRemoveTaskAssignmentDialog
  } = useDialogState(false);

  const {
    open: removeTaskAllocationDialogOpen,
    openDialog: openRemoveTaskAllocationDialog,
    closeDialog: closeRemoveTaskAllocationDialog
  } = useDialogState(false);

  const {
    open: changeTaskResourceDialogOpen,
    openDialog: openChangeTaskResourceDialog,
    closeDialog: closeChangeTaskResourceDialog
  } = useDialogState(false);

  const removeAssignmentAction = {
    label: formatMessage({
      id: 'taskAllocationActions.removeTaskAssignment'
    }),
    onClick: () => {
      openRemoveTaskAssignmentDialog();
    }
  };

  const changeTaskResource = {
    label: formatMessage({
      id: 'taskAllocationActions.changeResource'
    }),
    onClick: () => {
      openChangeTaskResourceDialog();
    }
  };

  const actions = [changeTaskResource];

  if (hasTaskAllocation) {
    const removeAllocatedTimeAction = {
      label: formatMessage({
        id: 'taskAllocationActions.removeAllocatedTime'
      }),
      onClick: () => {
        openRemoveTaskAllocationDialog();
      }
    };

    actions.push(removeAllocatedTimeAction);
  }
  actions.push(removeAssignmentAction);

  return {
    actions,
    removeTaskAssignmentDialogOpen,
    openRemoveTaskAssignmentDialog,
    closeRemoveTaskAssignmentDialog,
    removeTaskAllocationDialogOpen,
    closeRemoveTaskAllocationDialog,
    changeTaskResourceDialogOpen,
    closeChangeTaskResourceDialog
  };
};

export default useTaskAssignmentRowActions;
